export default "__VITE_ASSET__6804dc5f__"